import { render, staticRenderFns } from "./NavbarForGuest.vue?vue&type=template&id=64639cd7&lang=pug"
import script from "./NavbarForGuest.vue?vue&type=script&lang=ts"
export * from "./NavbarForGuest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports